export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true" data-testid="logo-mark">
    <rect x="1.5" y="1.5" width="45" height="45" rx="12" stroke="#E2B857" strokeWidth="2.4" fill="rgba(226,184,87,0.08)" />
    <path d="M10 30 L24 12 L27 16 L38 14 L30 22 L33 25 L24 24 L16 34 Z" fill="#E2B857" />
    <circle cx="35" cy="33" r="4.4" stroke="#E2B857" strokeWidth="2.2" fill="none" />
    <path d="M35 37.4 L35 42 M35 40 L38 40" stroke="#E2B857" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);
